import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { IGlobalComponent } from './IGlobalComponent';
import { InfoConfirmComponent } from './component/info-confirm/info-confirm.component';


/** @techmore/global 組件的調用方法 */
@Injectable()
export class GlobalComponentService {
  /** 放置 global 組件的宿主組件，需在宿主中註冊進此屬性中 */
  globalCmp?: IGlobalComponent;
  /** 進度條調用者註冊機 */
  processingRegister: string[] = [];
  /** 進度條是否顯示中 */
  isProgessBarOpening = false;

  constructor(
    private snackBar: MatSnackBar
  ) { }

  /**
   * 跳出警告訊息彈出視窗
   * @param message 訊息內容，可塞HTML字串
   * @param param title: 彈出視窗標題，若未帶入則使用預設值；afterClose 彈出視窗關閉後的回調函式
   */
  openInfoAlert(message: string, param?: {title?: string, afterClose?: () => void}): InfoConfirmComponent {
    if (!this.globalCmp) { throw new Error('globalCmp not ready'); }
    return this.globalCmp.openInfoAlert(message, param);
  }

  /**
   * 跳出訊息確認彈出視窗
   * @param message 訊息內容，可塞HTML字串
   * @param param title: 彈出視窗標題，若未帶入則使用預設值；afterConfirm: 點擊確認按鈕後的回調涵式；afterClose 彈出視窗(不是點確認按鈕)關閉後的回調函式
   */
  openInfoConfirm(message: string, param?: {title?: string, afterConfirm?: () => void, afterClose?: () => void}): InfoConfirmComponent {
    if (!this.globalCmp) { throw new Error('globalCmp not ready'); }
    return this.globalCmp.openInfoConfirm(message, param);
  }

  /**
   * 跳出錯誤訊息彈出視窗
   * @param message 訊息內容，可塞HTML字串
   * @param param title: 彈出視窗標題，若未帶入則使用預設值；afterClose 彈出視窗關閉後的回調函式；showCopyTip: 是否顯示複製到剪貼簿按鈕，預設為不顯示
   */
  openErrorAlert(message: string, param?: {title?: string, afterClose?: () => void, showCopyTip?: boolean}): InfoConfirmComponent {
    if (!this.globalCmp) { throw new Error('globalCmp not ready'); }
    return this.globalCmp.openErrorAlert(message, param);
  }

  /** 顯示進度條，返還一個 uuid，關閉時需代入 */
  openIndeterminateProgressBar(): string {
    if (!this.globalCmp) { throw new Error('globalCmp not ready'); }

    const uuid = _uuid();
    this.processingRegister.push(uuid);
    if (!this.isProgessBarOpening) {
      this.isProgessBarOpening = true;
      if (this.globalCmp ) this.globalCmp.openIndeterminateProgressBar();
    }
    return uuid;
  }

  /** 關閉進度條顯示。帶入開啟時返還的 uuid，如果還有未告知結束的進度則進度條不關閉；不帶入 uuid 則清空所有已註冊的進度並關閉進度條 */
  closeIndeterminateProgressBar(uuid?: string): void {
    if (!this.globalCmp) { throw new Error('globalCmp not ready'); }
    if (!this.isProgessBarOpening) { return; }

    if (uuid) {
      const fidx = this.processingRegister.findIndex(s => s === uuid);
      if (fidx !== -1) {
        this.processingRegister.splice(fidx, 1);
      }
      if (!this.processingRegister.length) {
        this.isProgessBarOpening = false;
        if (this.globalCmp ) this.globalCmp.closeIndeterminateProgressBar();
      }
    } else {
      this.isProgessBarOpening = false;
      if (this.globalCmp ) this.globalCmp.closeIndeterminateProgressBar();
      this.processingRegister = [];
    }
  }

  /**
   * Opens a snackbar with a message and an optional action.
   * @param message — The message to show in the snackbar.
   * @param action — The label for the snackbar action，defult is X.
   * @param config — [Additional configuration options](https://v8.material.angular.io/components/snack-bar/api#MatSnackBarConfig) for the snackbar, with default duration 1600 ms.
   */
  openSanckBar(message: string, action: string = 'X', config?: MatSnackBarConfig<any>) {
    // if (this.globalCmp ) this.globalCmp.openSanckBar(message, action, { duration: 1600, });
    const _cfg = { duration: 1600, ...config };
    this.snackBar.open(message, action, _cfg);
  }

  /** 關閉短語回饋 */
  closeSnackBar() {
    this.snackBar.dismiss();
  }
}

/** 產生 uuid。從 https://www.cythilya.tw/2017/03/12/uuid/ 參考 */
function _uuid() {
  let d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  // tslint:disable-next-line: only-arrow-functions
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    // tslint:disable-next-line: no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
